import {
  faCheckCircle,
  faCircleArrowUp,
  faExclamationCircle,
  faInfoCircle,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons'
import {
  Alert as MAlert,
  type AlertProps as MAlertProps,
  Text,
} from '@mantine/core'
import clsx from 'clsx'

import { Icon } from '../Icon/Icon'
import styles from './styles.module.css'

export type AlertProps = MAlertProps & {
  description?: string | React.ReactNode
  title?: string
  variant: 'error' | 'info' | 'premium' | 'success' | 'warning'
  withBorder?: boolean
}

export function Alert({
  description,
  title,
  variant,
  withBorder = false,
  ...props
}: AlertProps) {
  const variantStyles = {
    error: {
      bgClass: styles.rootError,
      descriptionColor: 'red.7',
      icon: faExclamationCircle,
      iconColor: 'red.4',
      titleClass: styles.titleError,
    },
    info: {
      bgClass: styles.rootInfo,
      descriptionColor: 'blue.7',
      icon: faInfoCircle,
      iconColor: 'blue.4',
      titleClass: styles.titleInfo,
    },
    premium: {
      bgClass: styles.rootPremium,
      descriptionColor: 'purple.7',
      icon: faCircleArrowUp,
      iconColor: 'purple.4',
      titleClass: styles.titlePremium,
    },
    success: {
      bgClass: styles.rootSuccess,
      descriptionColor: 'green.7',
      icon: faCheckCircle,
      iconColor: 'green.4',
      titleClass: styles.titleSuccess,
    },
    warning: {
      bgClass: styles.rootWarning,
      descriptionColor: 'orange.7',
      icon: faTriangleExclamation,
      iconColor: 'orange.4',
      titleClass: styles.titleWarning,
    },
  }

  const { bgClass, descriptionColor, icon, iconColor, titleClass } =
    variantStyles[variant] || {}

  return (
    <MAlert
      autoContrast={false}
      classNames={{
        root: clsx(styles.root, bgClass, withBorder && styles.withBorder),
        title: clsx(styles.title, titleClass),
      }}
      icon={<Icon color={iconColor} icon={icon} />}
      radius='sm'
      title={title}
      {...props}
    >
      <Text c={descriptionColor} fw={400} size='md'>
        {description}
      </Text>
    </MAlert>
  )
}
